const ASSIGNED_CAN_VIEW_FILTER_ID = "assignedcanviewfilter"

const getAssignedCanViewFilter = (user, boardUser, canViewField, assignedBoardUsersField) => {
  return {
    id: ASSIGNED_CAN_VIEW_FILTER_ID,
    hidden: true,
    filterBy: (record) => record.isPhantom || (user.can(record[canViewField]) || record[assignedBoardUsersField].includes(boardUser.id))
  }
}

export const SwivuStoreAssignedCanViewMixin = (Target, boardUsersStore, canViewField = "canView", assignedBoardUsersField = "assignedBoardUsers") => class extends Target {
  static get $name() {
    return "SwivuAssignedCanViewMixin"
  }

  static get configurable() {
    return {
      reapplyFilterOnUpdate: true
    }
  }

  applyState(state) {
    super.applyState(state);
    this.swivuAssignedViewStateChange();
  }

  swivuAssignedViewStateChange() {
    if (!this.currentBoardUser) {
      this.currentBoardUser = boardUsersStore.find((boardUser) => boardUser.userId === boardUsersStore.swivuCurrentUser.id)
    }
    if (!this.filters.find(filter => filter.id === ASSIGNED_CAN_VIEW_FILTER_ID)) {
      this.filters = [
        ...this.filters,
        getAssignedCanViewFilter(boardUsersStore.swivuCurrentUser, this.currentBoardUser, canViewField, assignedBoardUsersField)
      ]
    }
  }
}
